<template>
  <generic-container
    :title="$t('account')"
    icon="money"
    :header_buttons="header_buttons_transaction"
  >
    <div v-if="!account">
      <div class="ui icon error message">
        <i class="exclamation triangle icon"></i>
        <div class="content">
          <div class="header">{{ $t("no account associated yet") }}</div>
        </div>
      </div>
      <div class="ui green segment">
        <div class="ui two column very relaxed stackable grid">
          <div class="column">
            <h3 class="ui center aligned header">
              {{ $t("associate with existing account") }}
            </h3>
            <div class="ui form">
              <div class="field">
                <label for>{{ $t("account finder") }}</label>
                <div class="ui blue search" ref="account_search">
                  <div class="ui icon input">
                    <input
                      class="prompt"
                      type="text"
                      :placeholder="$t('search account')"
                    />
                    <i class="search icon"></i>
                  </div>
                  <div class="results"></div>
                </div>
              </div>
              <div class="field">
                <div class="ui one cards" v-if="selected_account">
                  <div class="card">
                    <div class="content">
                      <div class="header">{{ selected_account.name }}</div>
                      <div class="meta">{{ selected_account.number }}</div>
                      <div class="description">
                        <pre>{{ selected_account }}</pre>
                      </div>
                    </div>
                    <div class="extra content">
                      <div class="ui two buttons">
                        <div class="ui basic green button" @click="confirm">
                          {{ $t("confirm") }}
                        </div>
                        <div class="ui basic red button" @click="cancel">
                          {{ $t("cancel") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="middle aligned column">
            <h3 class="ui center aligned header">
              {{ $t("create new account") }}
            </h3>
            <div class="ui green fluid button" @click="create">
              <i class="star icon"></i>
              {{ $t("create") }}
            </div>
          </div>
        </div>
        <div class="ui vertical divider">{{ $t("or") }}</div>
      </div>
    </div>
    <div v-if="account">
      <div>
        <h2 class="ui header">
          <img src="/images/icons/accounts.png" />
          <div class="content">
            {{ account.name }}
            <div class="sub header">{{ account.number }}</div>
          </div>
        </h2>
      </div>
      <table
        class="ui very compact selectable celled striped table"
        ref="transaction_table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("type") }}</th>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("amount") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
    <template v-for="(mdl, index) in transaction_modals">
      <component
        :is="mdl"
        :key="index"
        :account_in="account"
        v-on:destroy="destroy_transaction"
        v-on:succedded="destroy_transaction"
      ></component>
    </template>
    <template v-for="(mdl, index) in detail_transaction_modals">
      <component
        :is="mdl"
        :key="index"
        :transaction_in="selected_transaction"
        v-on:destroy="destroy_detail_transaction"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import {
  local_api,
  stringify,
  init_search,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";
import TransactionDetailModal from "@/modules/account_transaction/TransactionDetailModal";
import TransactionModal from "@/modules/customer_account/transaction_modal/Index";

// @ is an alias to /src
export default {
  name: "CustomerAccountPlugin",
  components: { GenericContainer },
  props: { customer: Object },
  filters: filters,
  data() {
    return {
      account: undefined,
      transaction_modals: [],
      detail_transaction_modals: [],
      selected_movement: {},
      selected_transaction: {},
      selected_account: undefined,
      header_buttons_movement: [
        {
          icon: "green plus",
          click: this.add,
          tooltip: this.$t("register movement"),
        },
      ],
      header_buttons_transaction: [
        {
          icon: "green plus",
          click: this.add_transaction,
          tooltip: this.$t("register movement"),
        },
      ],
    };
  },
  methods: {
    add_transaction() {
      this.transaction_modals.push(TransactionModal);
    },
    destroy_transaction() {
      this.transaction_modals = [];
      this.selected_transaction = {};
    },
    destroy_detail_transaction() {
      this.detail_transaction_modals = [];
      this.selected_transaction = {};
    },
    details_transaction(transaction) {
      this.selected_transaction = transaction;
      this.detail_transaction_modals.push(TransactionDetailModal);
    },
    confirm() {
      let vm = this;
      local_api(vm, "post", "/customer_account/do-associate", {
        u: vm.customer.uuid,
        a: vm.selected_account.uuid,
      })
        .then((r) => {
          vm.account = r;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    cancel() {
      this.selected_account = undefined;
    },
    create() {
      let vm = this;
      local_api(vm, "post", "/customer_account/do-create", {
        u: vm.customer.uuid,
      })
        .then((r) => {
          vm.account = r;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    removed() {
      window.jQuery(".modal").modal("hide");
      this.load_account();
    },
    load_account() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      setTimeout(() => {
        if (vm.customer.uuid) {
          local_api(vm, "post", "/customer_account/do-get", {
            u: vm.customer.uuid,
          })
            .then((account) => {
              vm.account = account;

              if (
                account &&
                account.acc_transactions &&
                account.acc_transactions.length
              ) {
                vm.account.acc_transactions = vm.account.acc_transactions.map(
                  (t) => {
                    t.acc_transaction_type.setup = JSON.parse(
                      t.acc_transaction_type.setup,
                    );
                    return t;
                  },
                );
              }

              setTimeout(() => {
                if (account && account.acc_transactions) {
                  let columns = [
                    {
                      data: function(row) {
                        return row.acc_transaction_type.name;
                      },
                    },
                    {
                      data: function(row) {
                        return (
                          filters.formatDate(
                            row.create_date,
                            ent_setup.detailed_date_format,
                          ) || ""
                        );
                      },
                    },
                    {
                      data: function(row) {
                        return filters.formatCurrency(row.amount);
                      },
                    },
                  ];

                  let onSelect = (data) => {
                    vm.details_transaction(data);
                  };
                  let onCreatedRow = (row, data) => {
                    if (
                      data.acc_transaction_type &&
                      data.acc_transaction_type.setup
                    ) {
                      switch (data.acc_transaction_type.setup.affect) {
                        case "D":
                          window.jQuery(row).addClass("warning");
                          break;
                        default:
                          break;
                      }
                    }

                    setTimeout(() => {
                      window.jQuery(".ui.progress").progress();
                    }, 200);
                  };

                  init_json_local_data_datables(
                    vm,
                    vm.$refs.transaction_table,
                    vm.account.acc_transactions,
                    columns,
                    onSelect,
                    onCreatedRow,
                  );
                }
              }, 200);
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        } else vm.load_account();
      }, 500);
    },
  },
  mounted() {
    let vm = this;
    vm.load_account();
    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.name,
          description: r.number,
          account: r,
        });
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      vm.selected_account = data.account;
    };

    init_search(
      vm,
      this.$refs.account_search,
      "search account",
      onSearchResponse,
      onSearchSelect,
    );
  },
  created() {},
  watch: {
    filter() {},
  },
};
</script>

<style></style>
